// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__1_2UH","overflowing":"ReadFullNote_overflowing__35mM7"};